import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const SalesforcePCP = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [memberNotFound, setMemberNotFound] = useState(null);
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  useEffect(() => {
    console.log('Location search:', location.search);
    
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    
    // Dynamically extract all query parameters without altering case
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value; // Keep keys as they are
    });

    console.log('Extracted Query Parameters:', params); // Log the extracted parameters
    
    fetchSalesforcePCPURL(params);
  }, [location]);

  const fetchSalesforcePCPURL = async (params) => {
    try {
      console.log('Fetching Salesforce PCP URL with params:', params);
      const response = await axios.get(`${API_URL}/api/SalesforcePCP/GetSalesforcePCPUrl`, {
        params: {
          ...params
        }
      });

      console.log('API Response:', response.data);
      setLoading(false);

      if (response.data && response.data.url) {
        console.log('Navigating to Salesforce PCP URL:', response.data.url);
        window.location.href = response.data.url;
      } else if (response.data && response.data.redirectUrl) {
        console.log('Navigating to Salesforce PCP redirect URL:', response.data.redirectUrl);
        window.location.href = response.data.redirectUrl;
      } else {
        console.error('No URL received from API response');
        setError('salesforcepcp');
      }
    } catch (error) {
      console.error('Error fetching Salesforce PCP URL:', error);
      setLoading(false);
      
      // Handle BadRequest and other HTTP errors
      if (error.response && error.response.status === 404) {
        // Handle 404 - Member not found
        const memberId = params.memqnxtid || 'Unknown';
        setMemberNotFound(memberId);
      } else if (error.response && error.response.status === 400) {
        // Handle BadRequest - extract message from response
        const errorMessage = error.response.data?.Message || error.response.data?.message || 'Bad request occurred';
        setError(errorMessage);
      } else if (error.response) {
        // Handle other HTTP errors
        const errorMessage = error.response.data?.Message || error.response.data?.message || `HTTP Error: ${error.response.status}`;
        setError(errorMessage);
      } else {
        // Handle network or other errors
        setError('salesforcepcp');
      }
    }
  };

  return (
    <div>
      {memberNotFound ? (
        <div style={{
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          color: '#333',
          lineHeight: '1.6',
          border: '1px solid #4a90e2',
          borderRadius: '4px',
          padding: '30px 40px',
          backgroundColor: '#fff',
          width: 'calc(100vw - 40px)',
          height: 'calc(100vh - 40px)',
          margin: '20px',
          position: 'fixed',
          top: '0',
          left: '0',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontSize: '18px',
            marginBottom: '10px'
          }}>
            Member
          </div>
          <div style={{
            fontSize: '18px',
            marginBottom: '10px',
            fontWeight: 'bold'
          }}>
            {memberNotFound}
          </div>
          <div style={{
            fontSize: '18px',
            marginBottom: '30px'
          }}>
            not Found !
          </div>
          <div style={{
            fontSize: '18px',
            marginBottom: '30px'
          }}>
            PCP Not Found
          </div>
          <div style={{
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#000'
          }}>
            Salesforce
          </div>
          <div style={{
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#000'
          }}>
            PCP Update
          </div>
        </div>
      ) : (
        <table style={{backgroundColor: 'transparent', width: '100%', height: '100vh'}} cellPadding="0" cellSpacing="0">
          <tbody>
            <tr style={{height: '30%'}}>
              <td></td>
            </tr>
            <tr>
              <td style={{width: '30%'}}></td>
              <td align="center" style={{fontSize: 'x-large', verticalAlign: 'middle'}}>
                {error && <ErrorPage errorType="salesforcepcp" errorMessage={error !== 'salesforcepcp' ? error : undefined} />}
              </td>
              <td style={{width: '30%'}}></td>
            </tr>
            <tr>
              <td style={{width: '50%'}}></td>
              <td align="center" style={{fontSize: 'large'}}>
                {loading && !memberNotFound && (
                  <div style={{width: '99%'}}>
                    <div style={{marginLeft: '49%'}}>
                      <div style={{float: 'left'}}>
                        <img src={LoadingImage} id="loadinggif" alt="Loading" />
                      </div>
                      <div id="loadingtext" style={{float: 'left'}}> Loading...</div>
                    </div>
                  </div>
                )}
              </td>
              <td style={{width: '50%'}}></td>
            </tr>
            <tr>
              <td style={{width: '30%'}}></td>
              <td align="center">
                <div style={{fontSize: 'larger'}}></div>
              </td>
              <td style={{width: '30%'}}></td>
            </tr>
            <tr style={{height: '30%'}}>
              <td></td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SalesforcePCP;
